export interface BlogGroup {
  label: string;
  slugs: string[];
}

/** Catégories pour l'index des articles (même regroupement que le blog Asterion). */
export const BLOG_GROUPS: BlogGroup[] = [
  {
    label: 'Mon approche',
    slugs: [
      'notre-approche-qualite-pme-manufacturiere',
      'structurer-demarche-qualite-pme-manufacturiere',
    ],
  },
  {
    label: 'Le système qualité',
    slugs: [
      'rendre-iso-9001-accessible-pme-ia',
      'revue-direction-iso-9001-sans-consultant',
      'points-critiques-systeme-qualite',
      'maturite-systeme-qualite-pme',
      'jamais-vu-systeme-qualite-pme',
    ],
  },
  {
    label: 'Le rapport & la mesure',
    slugs: [
      'rapport-usinage-inspection-quatre-lectures',
      'cout-cache-temps-machiniste-rapports-inspection',
      'ocr-plans-cotes-manufacturier',
      'metrologie-hors-excel-etalonnage',
    ],
  },
  {
    label: 'IA, outils & organisation',
    slugs: [
      'ia-qualite-ce-quelle-peut-faire',
      'batir-logiciels-metier-ia-encadree',
      'innovateur-interne-adoption-logiciel-pme',
      'ecosysteme-pas-silos-bon-de-travail',
      'plans-heberges-quebec-loi-25',
    ],
  },
  {
    label: 'Près de chez vous',
    slugs: [
      'logiciel-qualite-usinage-sorel-tracy',
      'logiciel-qualite-usinage-drummondville',
      'logiciel-qualite-usinage-trois-rivieres-mauricie',
      'logiciel-qualite-usinage-montreal',
      'logiciel-qualite-usinage-saguenay-lac-saint-jean',
    ],
  },
];
